import React, { Fragment, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import OpenBtn from '../buttons/OpenBtn'
import EditBtn from '../buttons/EditBtn'
import DeleteBtn from '../buttons/DeleteBtn'
import NullMssg from '../common/NullMssg'
import _ from 'lodash'
import { mssgs } from '../../constantes/mssgs'
import PlusBtn from '../buttons/PlusBtn'
import NewContactNoteModal from './contactHospitals/NewContactNoteModal'
import HospitalModal from '../backoffice/hospitals/HospitalModal'
import { onSubmitText } from '../../constantes/onSubmitText'
import { hospitalsContactsActions } from '../../actions/hospitalsContactsActions'
import { zonesActions } from '../../actions/zonesActions'
import { hospitalsContactsTypes } from '../../constantes/actionTypes'
import { swalTitle } from '../../constantes/swalTitle'
import { swalSuccessGeneral } from '../../utils/swalAlert'
import { swalMssgs } from '../../constantes/swalMssgs'
import { swalAlertError } from '../../utils/swalAlert'
const ContactsHospitalsList = ({
  hospitalsContacts: hospitalsContactsProp,
  toViewContact,
  toEditContact,
  handleRemove,
  zones = [], // Agregar zones como prop
}) => {
  const hospitalsContacts = _.orderBy(
    hospitalsContactsProp,
    ['nombre'],
    ['asc'],
  )
  const dispatch = useDispatch()
  const businessUnits = useSelector((state) => state.businessunits)
  const getAllZones = () => dispatch(zonesActions.getAllZones())

  const createContactNote = (id_Contacto, contactNote) =>
    dispatch(
      hospitalsContactsActions.createContactNote(id_Contacto, contactNote),
    )

  const [newContactNote, setNewContactNote] = useState({})

  // Estado para el modal de hospital
  const [selectedHospital, setSelectedHospital] = useState({
    codigo: '',
    nombre: '',
    poblacion: '',
    id_TipoZona: '',
    direccion: '',
    comunidad_Autonoma: '',
    businessUnits: [],
  })
  const [hospitalModalIsOpen, setHospitalModalIsOpen] = useState(false)

  const [modalIsOpen, setIsOpen] = useState({
    createModal: false,
    editModal: false,
    hospitalModal: false,
  })

  const openNewModal = (id) => {
    setNewContactNote({ id_Contacto: id })
    setIsOpen({
      createModal: true,
      editModal: false,
    })
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      const response = await createContactNote(
        newContactNote.id_Contacto,
        newContactNote,
      )
      if (
        hospitalsContactsTypes.CREATE_HOSPITALS_CONTACT_NOTE_SUCCESS ===
        response.type
      ) {
        swalSuccessGeneral(swalTitle.CreadoCorrectamente, swalMssgs.NEW_SUCCES)
        closeModal()
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  const handleChangeNewContactNote = (e) => {
    const value = e.target.value
    const name = e.target.name
    setNewContactNote({ ...newContactNote, [name]: value })
  }

  const toHospitals = (hospitalContact) => {
    // Mapear los datos del hospital del contacto al formato del modal
    setSelectedHospital({
      codigo: hospitalContact.codigo || '',
      nombre: hospitalContact.nombre || '',
      poblacion: hospitalContact.poblacion || '',
      id_TipoZona: hospitalContact?.id_TipoZona || '',
      direccion: hospitalContact.direccion || '',
      comunidad_Autonoma: hospitalContact.comunidad_Autonoma || '',
      businessUnits: hospitalContact.id_NegocioUnidades || [],
    })

    // Cargar zones si no están cargadas
    if (zones.length === 0) {
      getAllZones()
    }

    setHospitalModalIsOpen(true)
  }

  const closeHospitalModal = () => {
    setHospitalModalIsOpen(false)
    setSelectedHospital({
      codigo: '',
      nombre: '',
      poblacion: '',
      id_TipoZona: '',
      direccion: '',
      comunidad_Autonoma: '',

      businessUnits: [],
    })
  }

  const renderLgpd = (contact) => {
    let resp = "";
    try {
      if(!contact.id_RespuestaLgpd && !contact.fechaVisitaLgpd) {
        return ""
      }
      if(contact.id_RespuestaLgpd >= 0)
        return (
          <span>
            {contact.fechaVisitaLgpd !== "" && (
              <>
                <span>{contact.fechaVisitaLgpd}</span>
                  {/* Eye icon SVG */}
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"
                      stroke="#888"
                      strokeWidth="2"
                      fill="none"
                    />
                    <circle
                      cx="12"
                      cy="12"
                      r="3"
                      stroke="#888"
                      strokeWidth="2"
                      fill="none"
                    />
                  </svg>
                  <br />
              </>
            )}
            {contact.fechaRespuestaLgpd !== "" && (
              <>
                <span>{contact.fechaRespuestaLgpd}</span>
                {contact.id_RespuestaLgpd == 1 ? (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M5 13l4 4L19 7"
                      stroke="#4caf50"
                      strokeWidth="2"
                      fill="none"
                    />
                  </svg>
                ) : (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <circle
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="#f44336"
                      strokeWidth="2"
                      fill="none"
                    />
                    <line
                      x1="8"
                      y1="8"
                      x2="16"
                      y2="16"
                      stroke="#f44336"
                      strokeWidth="2"
                    />
                    <line
                      x1="16"
                      y1="8"
                      x2="8"
                      y2="16"
                      stroke="#f44336"
                      strokeWidth="2"
                    />
                  </svg>
                )}
              </>
            )}
          </span>
        )
    } catch(err) {
      return "";
    }
  }

  return (
    <Fragment>
      <div className='table-wrapper'>
        <table className='contacts-hospitals-table'>
          <thead>
            <tr>
              <th style={{ minWidth: '320px', width: '320px'}}>
                Nombre
              </th>
              <th style={{ minWidth: '280px', width: '280px'}}>
                Email y Teléfono
              </th>
              <th style={{ minWidth: '280px', width: '280px'}}>
                Hospital / Centro
              </th>
              <th style={{ minWidth: '240px', width: '240px'}}>
                Especialidad
              </th>
              <th className="table-th-created" style={{ minWidth: '180px', width: '240px'}}>
                Creado
              </th>
              <th className="table-th-lgpd">
                Lgpd
              </th>
              <th className="table-th-actions" style={{ width: '220px', minWidth: '220px'}}>
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>
            {hospitalsContacts.length > 0 ? (
              hospitalsContacts.map((elem) => {
                // Si el contacto tiene hospitales, mostramos una fila por cada hospital
                if (
                  elem &&
                  elem.hospitalsContacts &&
                  elem.hospitalsContacts.length > 0
                ) {
                  return elem.hospitalsContacts.map(
                    (hospitalContact, index) => (
                      <tr
                        key={`${elem.id_Contacto}-${
                          hospitalContact.id_ContactoHospital || index
                        }`}
                        className={ elem.id_RespuestaLgpd === 2 ? 'table-tr-unsubscribed' : '' }
                      >
                        {/* Solo mostramos nombre, email y teléfono en la primera fila del contacto */}
                        {index === 0 && (
                          <>
                            <td rowSpan={elem.hospitalsContacts.length} className="table-td-header">
                              {elem.nombre}
                            </td>
                            <td rowSpan={elem.hospitalsContacts.length}>
                              {elem.email}
                              <br />
                              {elem.telf}
                            </td>
                          </>
                        )}
                        <td onClick={() => toHospitals(hospitalContact)}>
                            {hospitalContact.nombre}
                            <br />
                            {hospitalContact.nombreZona}
                        </td>
                        <td style={{ fontSize: '90%'}}>
                            {hospitalContact.hospitalSpeciality}
                        </td>
                        {index === 0 && (
                          <>
                            <td rowSpan={elem.hospitalsContacts.length}>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'flex-end',
                                }}
                              >
                                <span style={{ fontSize: '80%', textAlign: 'right' }}>
                                  {elem.fechaCreacion}<br />
                                  {elem.usuarioCreacionNombre}
                                </span>
                                {elem &&
                                  elem.id_NegocioUnidades &&
                                  elem.id_NegocioUnidades.map((unidad) => {
                                    return (
                                      <span
                                        key={unidad}
                                        style={{
                                          fontSize: '12px',
                                          color: '#666',
                                        }}
                                      >
                                        {businessUnits &&
                                          businessUnits.find(
                                            (bu) =>
                                              bu.id_NegocioUnidad === unidad,
                                          ) &&
                                          businessUnits.find(
                                            (bu) =>
                                              bu.id_NegocioUnidad === unidad,
                                          ).nombre}
                                      </span>
                                    )
                                  })}
                              </div>
                            </td>
                            <td rowSpan={elem.hospitalsContacts.length} className="table-td-lgpd">
                              {renderLgpd(elem)}
                            </td>
                          </>
                        )}
                        {/* Solo mostramos acciones en la primera fila del contacto */}
                        {index === 0 && (
                          <td className="table-td-actions" rowSpan={elem.hospitalsContacts.length}>
                            <button
                              onClick={() => openNewModal(elem.id_Contacto)}
                              title='Añadir nota'
                              className='action-button'
                            >
                              <span>{elem?.notasCount}</span>
                              <PlusBtn />
                            </button>
                            <button
                              onClick={() => toViewContact(elem.id_Contacto)}
                              title='Ver contacto'
                              className='action-button'
                            >
                              <OpenBtn />
                            </button>
                            <button
                              onClick={() => toEditContact(elem.id_Contacto)}
                              title='Editar contacto'
                              className='action-button'
                            >
                              <EditBtn />
                            </button>
                            <button
                              onClick={() => handleRemove(elem.id_Contacto)}
                              title='Eliminar contacto'
                              className='action-button'
                            >
                              <DeleteBtn />
                            </button>
                          </td>
                        )}
                      </tr>
                    ),
                  )
                } else {
                  // Si no tiene hospitales, mostramos una fila con datos vacíos para hospital
                  return (
                    <tr key={elem.id_Contacto}>
                      <td>
                        {elem.nombre}
                      </td>
                      <td>
                        {elem.email}
                        <br />
                        {elem.telf}
                      </td>
                      <td>
                        Sin hospital asignado
                      </td>
                      <td>
                        -
                      </td>
                      <td class="table-td-created" style={{ textAlign: 'right'}}>
                        {elem.usuarioCreacionNombre}
                      </td>
                      <td className="table-td-lgpd">
                        {renderLgpd(elem)}
                      </td>
                      <td className="table-td-actions">
                        <button
                          onClick={() => openNewModal(elem.id_Contacto)}
                          title='Añadir nota'
                          className='action-button'
                        >
                          <PlusBtn />
                        </button>
                        <button
                          onClick={() => toViewContact(elem.id_Contacto)}
                          title='Ver contacto'
                          className='action-button'
                        >
                          <OpenBtn />
                        </button>
                        <button
                          onClick={() => toEditContact(elem.id_Contacto)}
                          title='Editar contacto'
                          className='action-button'
                        >
                          <EditBtn />
                        </button>
                        <button
                          onClick={() => handleRemove(elem.id_Contacto)}
                          title='Eliminar contacto'
                          className='action-button'
                        >
                          <DeleteBtn />
                        </button>
                      </td>
                    </tr>
                  )
                }
              })
            ) : (
              <tr>
                <td colSpan='7'>
                  <NullMssg mssg={mssgs.NADA_QUE_MOSTRAR_AÑADIR_CONTACTOS} />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <NewContactNoteModal
        newContactNote={newContactNote}
        modalIsOpen={modalIsOpen.createModal}
        closeModal={closeModal}
        handleSubmit={handleSubmit}
        handleChange={handleChangeNewContactNote}
        // validateForm={validateFormNew}
        textBtn={onSubmitText.Crear}
      />

      {/* Modal para ver el hospital en modo solo lectura */}
      <HospitalModal
        modalIsOpen={hospitalModalIsOpen}
        closeModal={closeHospitalModal}
        inputs={selectedHospital}
        zones={zones}
        businessunits={businessUnits}
        handleChange={() => {}}
        handleBusinessUnitsChange={() => {}}
        handleSubmit={() => {}}
        validateForm={true} 
        textBtn='' // Sin botón de acción
        isEdit={false}
        isViewMode={true} // Modo de solo lectura
      />
    </Fragment>
  )
}

export default ContactsHospitalsList
